import Vue from 'vue';

const EventBus = new Vue();

const EVENTS = {
  SET_COOKIES: 'SET_COOKIES',
  RESTART_SYNC: 'RESTART_SYNC',
  STOP_SYNC: 'STOP_SYNC',
  IMMEDIATE_SYNC: 'IMMEDIATE_SYNC',
  ROUTE_PUSHED: 'ROUTE_PUSHED',
  MCE_INSERT_TEXT: 'MCE_INSERT_TEXT',
  ASSESSMENT_CHANGED: 'ASSESSMENT_CHANGED'
}

export { EventBus, EVENTS };
